/// <reference path="../../../../Modules/Attr/Dialog/NoboxEntityDialog.ts" />
namespace Nobox {

    @Serenity.Decorators.registerClass()
    export class DialogErrorDialog extends NoboxEntityDialog<ChatroomsRow, any> {
        protected getFormKey() { return DialogErrorForm.formKey; }

        protected form = new DialogErrorForm(this.idPrefix);
        constructor(container?: JQuery) {
            super(container);
        }
        protected updateTitle() {
            this.dialogTitle = "Error Message";
        }
        getToolbarButtons() {
            var buttons = [] as Serenity.ToolButton[];
            buttons.push({
                title: "Copy Error",
                icon: "fa-copy",
                onClick: () => {
                    var link = document.createElement('textarea');
                    link.value = `${this.form.ErrorMessage.value}`;
                    link.select();
                    link.setSelectionRange(0, 99999);
                    navigator.clipboard.writeText(link.value);
                    Q.notifySuccess("Error Message copied to clipboard");
                }
            })
            return buttons;
        }
    }
}